/**
 * NotSetup fallback screen (fix #252 / #PL-WEB-RUBRICS).
 *
 * Shown when the player receives a `scoring_rubric` that doesn't
 * match any of the 5 archetype shapes (AC #5). The kid sees a
 * kid-friendly message and a "Back to activities" button so they
 * can return to the home screen.
 */
import type { ReactElement } from 'react';

export interface NotSetupScreenProps {
  reason: string;
  onBackToActivities: () => void;
}

export default function NotSetupScreen({
  reason,
  onBackToActivities,
}: NotSetupScreenProps): ReactElement {
  return (
    <main className="screen handoff">
      <div className="auth-hero">
        <header className="screen-header">
          <h1>This activity isn&rsquo;t set up yet</h1>
          <p className="tagline">
            Your SLP is still prepping this one. Check back soon!
          </p>
        </header>
      </div>
      <p className="tagline" role="status">
        ({reason})
      </p>
      <button
        type="button"
        className="snap-button"
        onClick={onBackToActivities}
      >
        Back to activities
      </button>
    </main>
  );
}
